module.exports = __webpack_public_path__ + "static/media/survey_popup.354c4332.png";